import { render, staticRenderFns } from "./AdminDocumentMaster.vue?vue&type=template&id=8e0b0c32&"
import script from "./AdminDocumentMaster.vue?vue&type=script&lang=js&"
export * from "./AdminDocumentMaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports